import { staticColors } from '../../const/colors/staticColors';
export const getHintBackgroundColor = (hintVariant) => {
    const colorMap = {
        action: staticColors.hintActionBackground,
        warning: staticColors.hintWarningBackground,
        danger: staticColors.hintDangerBackground,
        information: staticColors.hintInformationBackground,
        default: staticColors.hintDefaultBackground,
    };
    return colorMap[hintVariant];
};
export const getIconProps = (hintVariant) => {
    const propMap = {
        action: {
            color: 'action',
            name: 'Check',
        },
        warning: {
            color: 'warning',
            name: 'WarningAmber',
        },
        danger: {
            color: 'danger',
            name: 'ErrorOutline',
        },
        information: {
            color: 'greyLight',
            name: 'LightbulbOutline',
        },
        default: {
            color: 'warning',
            name: 'InfoOutline',
        },
    };
    return propMap[hintVariant];
};
